import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {TransfersTabModel} from "../transfers.tab-model";
import {NEW_COMPETITOR_CONTAINER} from "../../../../../containers/competitor-container/competitor-container.consts";
import {CompetitorTransfersPageLinkModel} from "../../../../../containers/competitor-container/pages/transfers-page/models/competitor.transfers-page.link-model";
import type {CompetitorViewModel} from "../../../../../domain/common/competitor/models/competitor-view-model";

export class CompetitorTransfersPageTabModel extends TransfersTabModel {
  index: Number;
  name: String;
  entity: CompetitorViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitorViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @computed get linkModel(): CompetitorTransfersPageLinkModel {
    const linkModel: CompetitorTransfersPageLinkModel = new CompetitorTransfersPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === NEW_COMPETITOR_CONTAINER.FILTERS.transfers;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competitor;
  }
}
